<!-- @format -->

<a
	hmf-text-link
	[linkURL]="brandLink().url"
	[dataEm]="dataEm()"
	[size]="size()"
	variant="tertiary">
	{{ brandLink().name }}
</a>
